import type { EventMetricData } from './types';

const getCategoryForMetricName = (name: EventMetricData['name']): string => {
  const splitName = name.split('.');
  return splitName[0];
};

export { getCategoryForMetricName };
